module.exports = __webpack_public_path__ + "img/code1.f2377f62.png";